import { render, staticRenderFns } from "./ResultForm.vue?vue&type=template&id=dfb499b4"
import script from "./ResultForm.vue?vue&type=script&lang=js"
export * from "./ResultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports